import ProcoDocsItem from "./ProcoDocsItem";

export default function ProcoDocsDetails({uploadedFile, inWorkQ}) {

    return <>
        <ProcoDocsItem uploadedFile={uploadedFile} inWorkQ={inWorkQ}/>
    </>
}
